import { render, staticRenderFns } from "./BaseInfoBar.vue?vue&type=template&id=7f27dd13"
import script from "./BaseInfoBar.vue?vue&type=script&lang=js"
export * from "./BaseInfoBar.vue?vue&type=script&lang=js"
import style0 from "./BaseInfoBar.vue?vue&type=style&index=0&id=7f27dd13&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports